export default __webpack_public_path__ + "static/media/Shadow's Boots of the Stolen Kingdom.55da3349.jpg";